import useAuth from 'hooks/useAuth';
import { useQuery } from 'react-query';

export default function useConnectionTest() {
  const { request } = useAuth();
  const { data, isLoading } = useQuery('/connection-test', () =>
    request.post('/connection-test/', {}).then((response) => response?.data || {})
  );
  return { testSession: data, isLoading };
}
